export default "__VITE_ASSET__15dfb851__"